<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">Readers love</span> <span class="t3">Weathering the Storm</span></p>
<p class="p0"><span class="t2">by</span> <span class="t4">C</span><span class="t5">AITLIN</span> <span class="t4">R</span><span class="t5">ICCI</span></p>
<p class="p2"> </p>
<p class="p0"><img alt="img1.jpg" src="Images/img1.jpg"/></p>
<p class="p0"><span class="t7"> </span></p>
<p class="p3"><span class="t7">“If you love stories about the coming out stage for a young teen, then this book is for you. I can honestly say that it is well told and Caitlin put her heart into it.”</span></p>
<p class="p4"><span class="t7">—MM Good Book Reviews</span></p>
<p class="p5"><span class="t7">“This is a book I’d recommend to anyone looking for a gift for a gay youngster—or, really, any kid who likes horses.”</span></p>
<p class="p4"><span class="t7">—The Book Breeze</span></p>
<p class="p5"><span class="t7">“</span><span class="t8">Weathering the Storm</span> <span class="t7">was an excellent, well-written tale with realistic and enjoyable characters.”</span></p>
<p class="p4"><span class="t7">—Prism Book Alliance</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?07823a5a